import type { ReactNode } from 'react';

import { Text, Title } from '~/components';

import { sectionHeaderStyle, sectionStyle } from './contactFormSections.css';

type Props = {
  children: ReactNode;
  description?: ReactNode;
  id?: string;
  title: string;
};

export const ContactFormSection = ({ children, description, id, title }: Props) => {
  return (
    <section className={sectionStyle} id={id}>
      <div className={sectionHeaderStyle}>
        <Title as="h2" styleAs="h3">
          {title}
        </Title>

        {description && <Text>{description}</Text>}
      </div>

      {children}
    </section>
  );
};
